import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;

/**
 * Upload a file to S3 via the backend upload endpoint.
 *
 * @param {File}     file          - The File object to upload.
 * @param {Function} setImageUrl   - State setter; receives (prev => ({...prev, [key]: url})).
 * @param {string}   key           - The state key to update (e.g. "Image1", "ImageUrls").
 * @param {string}   [category="project"] - Upload category: "project" or "product".
 * @returns {string|undefined} The permanent S3 URL on success, undefined on failure.
 */
export async function uploadToS3(file, setImageUrl, key, category = "project") {
  const token = localStorage.getItem("accessToken");

  if (!file) {
    toast.error("No file selected");
    return undefined;
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axios.post(
      `${BASE_URL}api/uploads/${category}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // The backend returns the S3 URL in commonResponse
    const url = response.data?.commonResponse || response.data?.Result;

    if (!url || typeof url !== "string") {
      console.error("Upload succeeded but no URL returned:", response.data);
      toast.error("Upload succeeded but no URL was returned");
      return undefined;
    }

    // Update state via the provided setter
    if (typeof setImageUrl === "function") {
      setImageUrl((prevData) => ({
        ...prevData,
        [key]: url,
      }));
    }

    return url;
  } catch (error) {
    const serverMessage =
      error.response?.data?.message ||
      error.response?.data?.errorMessage?.[0]?.message ||
      error.message ||
      "Unknown upload error";

    console.error("Error uploading file:", serverMessage, error);
    toast.error(`Error uploading file: ${serverMessage}`);
    return undefined;
  }
}
